document.addEventListener('DOMContentLoaded', function () {
    const swiperContainer = document.querySelector('.creation-swiper');
    if (swiperContainer) {
        new Swiper(swiperContainer, {
            slidesPerView: 1.5,
            spaceBetween: 20, // default gap for mobile
            breakpoints: {
                992: {
                    slidesPerView: 2.5,
                    spaceBetween: 30, // gap from original SCSS
                }
            }
        });
    }
});
